import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'

import { Icon } from 'controlled-components'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.picker.canonical.paste')

const CLEAR_ICON_SIZE = 12

type Props = {
  pastedCount: number
  onClear: () => void
}

/** Stands in the search while it holds pasted uids; clearing it goes back to the whole list */
const PastedUidsChip = ({ pastedCount, onClear }: Props) => (
  <span className="d-inline-flex align-items-center border rounded bg-white px-s py-xxs">
    <Text.BodyText4 color="grey70">
      {t('chip', { count: pastedCount })}
    </Text.BodyText4>
    <Button
      kind="minimal"
      size="small"
      className="ml-xs p-0"
      aria-label={t('clear')}
      onClick={onClear}
    >
      <Icon name="x" size={CLEAR_ICON_SIZE} aria-hidden="true" />
    </Button>
  </span>
)

export default PastedUidsChip
